import { render } from "./DialogModal.vue?vue&type=template&id=51f49bf3"
import script from "./DialogModal.vue?vue&type=script&lang=js"
export * from "./DialogModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniokatarov/PhpstormProjects/MAR WHS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__